import { config } from "@/utils/config";
import { omniAxios } from "@/utils/axios";

// 采购意向通用搜索
export function restWebsiteSearchSolrPurchase({
  newAreas, // 地区id
  startPlanPurchaseAmount, // 起始预采金额
  endPlanPurchaseAmount, // 结束预采金额
  purchaseDateType, // 预采日期类型
  startPlanPurchaseDate, // 预采日期起始时间
  endPlanPurchaseDate, //预采日期结束时间
  threeClassifyTagStr, // 采购类别
  purchasingUnitIdList, //采购单位集合
  timeType, // 发布时间
  beginTime, // 开始时间
  endTime, // 结束时间
  filterMode, // 搜索范围
  keywords, // 搜索词
  excludeWord, // 排除词
  searchMode, // 搜索模式
  currentPage, // 当前页
  numPerPage, // 每页条数
  sortType, // 排序方式
  keywordsAndOr, // 关键字关系
  tenderees, // 采购单位名称
  smallKeywords, // 小搜索关键词
  smallFilterMode, // 小搜索搜索范围
  formSource, // 类型
}) {
  return omniAxios({
    url: config.restWebsiteSearchSolrPurchasePath,
    method: "post",
    cancelLastSameRequest: true,
    params: {
      newAreas, // 地区id
      startPlanPurchaseAmount, // 起始预采金额
      endPlanPurchaseAmount, // 结束预采金额
      purchaseDateType, // 预采日期类型
      startPlanPurchaseDate, // 预采日期起始时间
      endPlanPurchaseDate, //预采日期结束时间
      threeClassifyTagStr, // 采购类别
      purchasingUnitIdList, //采购单位集合
      timeType, // 发布时间
      beginTime, // 开始时间
      endTime, // 结束时间
      filterMode, // 搜索范围
      keywords, // 搜索词
      excludeWord, // 排除词
      searchMode, // 搜索模式
      currentPage, // 当前页
      numPerPage, // 每页条数
      sortType, // 排序方式
      keywordsAndOr, // 关键字关系
      tenderees, // 采购单位名称
      smallKeywords, // 小搜索关键词
      smallFilterMode, // 小搜索搜索范围
      formSource, // 类型
    },
  });
}

// 导出全部接口
export function restExportPurchase({
  newAreas, // 地区id
  startPlanPurchaseAmount, // 起始预采金额
  endPlanPurchaseAmount, // 结束预采金额
  purchaseDateType, // 预采日期类型
  startPlanPurchaseDate, // 预采日期起始时间
  endPlanPurchaseDate, //预采日期结束时间
  threeClassifyTagStr, // 采购类别
  purchasingUnitIdList, //采购单位集合
  timeType, // 发布时间
  beginTime, // 开始时间
  endTime, // 结束时间
  filterMode, // 搜索范围
  keywords, // 搜索词
  excludeWord, // 排除词
  searchMode, // 搜索模式
  currentPage, // 当前页
  numPerPage, // 每页条数
  sortType, // 排序方式
  keywordsAndOr, // 关键字关系
  tenderees, // 采购单位名称
  smallKeywords, // 小搜索关键词
  smallFilterMode, // 小搜索搜索范围
  formSource, // 类型
  exportType,
  exportSource,
  exportKeyword,
  fieldType,
  hitWord,
  subscribeId,
}) {
  return omniAxios({
    url: config.restExportPurchasePath,
    method: "post",
    params: {
      newAreas, // 地区id
      startPlanPurchaseAmount, // 起始预采金额
      endPlanPurchaseAmount, // 结束预采金额
      purchaseDateType, // 预采日期类型
      startPlanPurchaseDate, // 预采日期起始时间
      endPlanPurchaseDate, //预采日期结束时间
      threeClassifyTagStr, // 采购类别
      purchasingUnitIdList, //采购单位集合
      timeType, // 发布时间
      beginTime, // 开始时间
      endTime, // 结束时间
      filterMode, // 搜索范围
      keywords, // 搜索词
      excludeWord, // 排除词
      searchMode, // 搜索模式
      currentPage, // 当前页
      numPerPage, // 每页条数
      sortType, // 排序方式
      keywordsAndOr, // 关键字关系
      tenderees, // 采购单位名称
      smallKeywords, // 小搜索关键词
      smallFilterMode, // 小搜索搜索范围
      formSource, // 类型
      exportType,
      exportSource,
      exportKeyword,
      fieldType,
      hitWord,
      subscribeId,
    },
  });
}

// 选中导出接口
export function restAccountExportPurchaseClick({
  newAreas, // 地区id
  startPlanPurchaseAmount, // 起始预采金额
  endPlanPurchaseAmount, // 结束预采金额
  purchaseDateType, // 预采日期类型
  startPlanPurchaseDate, // 预采日期起始时间
  endPlanPurchaseDate, //预采日期结束时间
  threeClassifyTagStr, // 采购类别
  purchasingUnitIdList, //采购单位集合
  timeType, // 发布时间
  beginTime, // 开始时间
  endTime, // 结束时间
  filterMode, // 搜索范围
  keywords, // 搜索词
  excludeWord, // 排除词
  searchMode, // 搜索模式
  currentPage, // 当前页
  numPerPage, // 每页条数
  sortType, // 排序方式
  keywordsAndOr, // 关键字关系
  tenderees, // 采购单位名称
  smallKeywords, // 小搜索关键词
  smallFilterMode, // 小搜索搜索范围
  formSource, // 类型
  exportType,
  exportSource,
  exportKeyword,
  fieldType,
  hitWord,
  purchaseIds,
}) {
  return omniAxios({
    url: config.restAccountExportPurchaseClickPath,
    method: "post",
    params: {
      newAreas, // 地区id
      startPlanPurchaseAmount, // 起始预采金额
      endPlanPurchaseAmount, // 结束预采金额
      purchaseDateType, // 预采日期类型
      startPlanPurchaseDate, // 预采日期起始时间
      endPlanPurchaseDate, //预采日期结束时间
      threeClassifyTagStr, // 采购类别
      purchasingUnitIdList, //采购单位集合
      timeType, // 发布时间
      beginTime, // 开始时间
      endTime, // 结束时间
      filterMode, // 搜索范围
      keywords, // 搜索词
      excludeWord, // 排除词
      searchMode, // 搜索模式
      currentPage, // 当前页
      numPerPage, // 每页条数
      sortType, // 排序方式
      keywordsAndOr, // 关键字关系
      tenderees, // 采购单位名称
      smallKeywords, // 小搜索关键词
      smallFilterMode, // 小搜索搜索范围
      formSource, // 类型
      exportType,
      exportSource,
      exportKeyword,
      fieldType,
      hitWord,
      purchaseIds,
    },
  });
}

// 收藏
export function restCollectControllerAddPurchaseCollect({ contentList }) {
  return omniAxios({
    url: config.restCollectControllerAddPurchaseCollectPath,
    method: "post",
    params: {
      contentList,
    },
  });
}

// 批量移出收藏
export function restCollectControllerCancelPurchaseCollect({ contentList }) {
  return omniAxios({
    url: config.restCollectControllerCancelPurchaseCollectPath,
    method: "post",
    params: {
      contentList,
    },
  });
}
// 用户是否领取&购买有采购意向
export function restApplicationPurchasePermissionInfo() {
  return omniAxios({
    url: config.restApplicationPurchasePermissionInfoPath,
    method: "get",
    params: {},
  });
}

// 用户免费领取采购意向
export function restApplicationPurchasePermissionReceive() {
  return omniAxios({
    url: config.restApplicationPurchasePermissionReceivePath,
    method: "get",
    params: {},
  });
}

// 采购意向支付弹窗信息
export function restPayPayDialogInfoGetBuyPurchaseInfo() {
  return omniAxios({
    url: config.restPayPayDialogInfoGetBuyPurchaseInfoPath,
    method: "get",
    params: {},
  });
}
// 采购意向订阅器创建权限
export function restAccountCompanySpaceCheckPurchaseSubPermission() {
  return omniAxios({
    url: config.restAccountCompanySpaceCheckPurchaseSubPermissionPath,
    method: "get",
  });
}

// 采购意向订阅器全部导出
export function restAccountExportPurchaseSubscriberExportCheck(params) {
  return omniAxios({
    url: config.restAccountExportPurchaseSubscriberExportCheckPath,
    method: "post",
    params,
  });
}
